import React, {FC} from 'react';
import styled from 'styled-components';
import {defineMessages, useIntl} from 'react-intl';
import {CustomButton} from '../../../../../components/UI/AntCustom/CustomButton';
import {NewTripRequestPageMessages} from '../NewTripRequestPageMessages';

const SubmitBlockWrapper = styled.div`
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 24px 16px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

const SectionTitle = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
`;

const SelectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`;

const SelectionText = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
`;

const SubmitBlockMessages = defineMessages({
  selectedPlanes: {
    id: 'newTripRequestPage.selectedPlanes',
    defaultMessage: 'Выбрано {count} {word}',
  },
});

// Функция для правильного склонения слова "самолёт" / "aircraft"
const getPlaneWord = (count: number, locale: string): string => {
  // Для английского языка
  if (locale.startsWith('en')) {
    return count === 1 ? 'aircraft' : 'aircraft';
  }
  
  // Для русского языка
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  // Для чисел 11-14 всегда "самолётов"
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'самолётов';
  }
  
  // Для последней цифры 1 - "самолёт"
  if (lastDigit === 1) {
    return 'самолёт';
  }
  
  // Для последней цифры 2, 3, 4 - "самолёта"
  if (lastDigit >= 2 && lastDigit <= 4) {
    return 'самолёта';
  }
  
  // Для остальных - "самолётов"
  return 'самолётов';
};

interface ISubmitBlock {
  title?: string;
  selectedFlightsCount: number;
  onCreateRequest?: () => void;
}

export const SubmitBlock: FC<ISubmitBlock> = ({ 
  title, 
  selectedFlightsCount,
  onCreateRequest 
}) => {
  const intl = useIntl();
  const locale = intl.locale || 'en';

  return (
    <SubmitBlockWrapper>
      {title && (
        <SectionHeader>
          <SectionTitle>{title}</SectionTitle>
        </SectionHeader>
      )}
      <SelectionRow>
        {selectedFlightsCount > 0 && (
          <SelectionText>
            {intl.formatMessage(SubmitBlockMessages.selectedPlanes, { 
              count: selectedFlightsCount,
              word: getPlaneWord(selectedFlightsCount, locale)
            })}
          </SelectionText>
        )}
        <CustomButton 
          type="primary" 
          disabled={selectedFlightsCount === 0}
          onClick={onCreateRequest}
        >
          {intl.formatMessage(NewTripRequestPageMessages.createRequest)}
        </CustomButton>
      </SelectionRow>
    </SubmitBlockWrapper>
  );
};

